module.exports = __webpack_public_path__ + "static/img/bestImg2.2d1ef28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/bestImg2.png
// module id = Fsa9
// module chunks = 1